'use client';

import { css, FlattenSimpleInterpolation } from 'styled-components';

type Insets = number | { top?: number; right?: number; bottom?: number; left?: number };

/**
 * Grows a Button/IconButton's tappable area toward a target size (e.g. the
 * 44x44 minimum) without touching its visible size, by resizing the
 * hover/press `::before` pseudo-element that ships from Button's own styles.
 * That pseudo-element is `width: 100%; height: 100%` of the button by
 * default, so it must be reset to `auto` here — otherwise the box stays
 * over-constrained at its original size and the inset offsets below get
 * silently dropped instead of expanding it.
 *
 * Pass a single number for a symmetric expansion on all four sides, or a
 * partial object to expand asymmetrically (e.g. when an ancestor clips one
 * side and the shortfall has to be made up on the others).
 */
export const expandTapTarget = (insets: Insets): FlattenSimpleInterpolation => {
	const {
		top = 0,
		right = 0,
		bottom = 0,
		left = 0,
	} = typeof insets === 'number' ? { top: insets, right: insets, bottom: insets, left: insets } : insets;

	return css`
		&::before {
			width: auto;
			height: auto;
			top: -${top}px;
			right: -${right}px;
			bottom: -${bottom}px;
			left: -${left}px;
		}
	`;
};
